/* Progressive controls for the Workwear stream. Native forms remain usable without JS. */
(() => {
  'use strict';
  const money = cents => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
  // Quote: intent first, then a few taps, then contact. Without JS every step shows as one form.
  document.querySelectorAll('[data-ww-quote]').forEach(form => {
    const steps = [...form.querySelectorAll('[data-ww-step]')];
    if (!steps.length || form.querySelector('.ww-form-error, .ww-empty')) return; // after a post, leave the page as Shopify rendered it
    const $ = sel => form.querySelector(sel);
    const bar = $('[data-ww-quote-bar]'), count = $('[data-ww-quote-count]'), next = $('[data-ww-quote-next]');
    const context = $('[data-ww-quote-context]'), body = $('[data-ww-field="body"]'), org = $('[data-ww-field="org"]');
    const params = new URLSearchParams(location.search);
    const LOGO = { team: 'Embroider our logo', buy: 'No logo' };
    const NEED = [[/hi-?vis/i, 'Hi-vis'], [/boot|footwear|shoe/i, 'Safety boots'], [/ppe|glove|glasses|hearing|mask|respirat/i, 'PPE and gloves'],
      [/scrub|health|medical|nurs/i, 'Scrubs'], [/chef|hospitality|apron|kitchen/i, 'Chef and hospitality'],
      [/first aid|site safety|sign|barrier/i, 'Site safety and first aid'], [/shirt|pant|short|jacket|polo|clothing|trouser|overall/i, 'Work shirts and pants']];
    const MSG = { 'contact[name]': 'Add your name so we know who to reply to.', 'contact[email]': 'Enter an email we can reply to, like name@business.com.au.',
      'contact[body]': 'Write your question so we can answer it.', 'contact[Organisation]': 'Add your business name so we can set up the account.' };
    let intent = null, step = 1, pointer = false;
    form.noValidate = true;
    next.hidden = false;

    const hidden = (name, value) => {
      let el = form.querySelector(`input[type="hidden"][name="contact[${name}]"]`);
      if (!value) { if (el) el.remove(); return; }
      if (!el) { el = Object.assign(document.createElement('input'), { type: 'hidden', name: `contact[${name}]` }); form.append(el); }
      el.value = value;
    };
    const tick = need => { const box = form.querySelector(`input[name="contact[Need: ${need}]"]`); if (box) box.checked = true; };
    const swap = (el, attr) => {
      if (!el) return;
      el.dataset.wwDefault ??= el.innerHTML;
      el.innerHTML = el.getAttribute(`${attr}-${intent}`) ?? el.dataset.wwDefault;
    };
    const clearErrors = () => form.querySelectorAll('.ww-field-error').forEach(e => {
      e.previousElementSibling?.removeAttribute('aria-invalid');
      e.closest('[aria-invalid]')?.removeAttribute('aria-invalid');
      e.remove();
    });
    const error = (target, text) => {
      const p = Object.assign(document.createElement('p'), { className: 'ww-field-error', textContent: text, id: `ww-err-${Math.random().toString(36).slice(2, 8)}` });
      if (target.matches('fieldset')) { target.append(p); target.setAttribute('aria-invalid', 'true'); }
      else { target.after(p); target.setAttribute('aria-invalid', 'true'); target.setAttribute('aria-describedby', p.id); }
      return target;
    };
    const visible = el => !el.closest('[hidden], fieldset[disabled]');

    function choose(input) {
      intent = input.dataset.intent;
      form.querySelectorAll('[data-ww-for]').forEach(el => {
        const on = el.dataset.wwFor.split(' ').includes(intent);
        el.hidden = !on; el.disabled = !on;
      });
      form.querySelectorAll('[data-ww-label-buy], [data-ww-label-trade]').forEach(el => swap(el, 'data-ww-label'));
      swap($('#ww-order-help'), 'data-ww-help');
      const ask = intent === 'ask', trade = intent === 'trade';
      body.querySelector('textarea').required = ask;
      body.querySelector('[data-ww-optional]').hidden = ask;
      org.querySelector('input').required = trade;
      org.querySelector('[data-ww-optional]').hidden = trade;
      org.querySelector('[data-ww-org-label]').textContent = trade ? 'Business name' : 'Business or organisation';
      hidden('Logo', LOGO[intent]);
    }
    function show(n, focus = true) {
      step = n;
      clearErrors();
      steps.forEach(s => { s.hidden = Number(s.dataset.wwStep) !== n; });
      bar.hidden = n === 1;
      count.textContent = `Step ${n} of 3`;
      if (!focus) return;
      const head = [...steps[n - 1].querySelectorAll('.ww-quote__legend, legend')].find(visible) || steps[n - 1];
      head.tabIndex = -1;
      head.focus({ preventScroll: true });
      form.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function valid() {
      clearErrors();
      let first = null;
      const scope = steps[step - 1];
      scope.querySelectorAll('[data-ww-required]').forEach(set => {
        if (visible(set) && !set.querySelector('input:checked')) { const e = error(set, set.dataset.wwRequired); first ??= e; }
      });
      scope.querySelectorAll('input[required], textarea[required]').forEach(el => {
        if (visible(el) && !el.checkValidity()) { const e = error(el, MSG[el.name] || 'Fill this in.'); first ??= e; }
      });
      if (first) (first.matches('fieldset') ? first.querySelector('input') : first).focus();
      return !first;
    }

    const tiles = $('[data-ww-step="1"]');
    tiles.addEventListener('pointerdown', () => { pointer = true; });
    tiles.addEventListener('keydown', event => {
      if (!event.target.matches('[data-intent]') || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      event.target.checked = true; choose(event.target); show(2);
    });
    form.addEventListener('change', event => {
      if (!event.target.matches('[data-intent]')) return;
      choose(event.target);
      if (pointer) show(2); // arrow keys only move the selection; a tap or Enter moves on
      pointer = false;
    });
    form.addEventListener('input', event => {
      const err = event.target.matches('input, textarea') && event.target.nextElementSibling;
      if (err?.matches('.ww-field-error') && event.target.checkValidity()) { err.remove(); event.target.removeAttribute('aria-invalid'); }
    });
    form.addEventListener('change', event => {
      const set = event.target.closest('[data-ww-required][aria-invalid]');
      if (set?.querySelector('input:checked')) { set.querySelector('.ww-field-error')?.remove(); set.removeAttribute('aria-invalid'); }
    });
    $('[data-ww-quote-back]').addEventListener('click', () => show(step - 1));
    next.addEventListener('click', () => { if (valid()) show(3); });
    form.addEventListener('submit', event => {
      if (step < 3) { event.preventDefault(); if (step === 2 && valid()) show(3); return; }
      if (!valid()) { event.preventDefault(); return; }
      if (form.matches('[data-ww-quote-preview]')) {
        event.preventDefault();
        const message = $('[data-ww-quote-message]');
        message.textContent = 'This is a preview. Your request has not been sent.';
        message.hidden = false;
        return;
      }
      const send = form.querySelector('button[type="submit"]');
      send.textContent = 'Sending';
      send.setAttribute('aria-disabled', 'true');
    });

    // Context from the link that brought them here: ?intent=team&need=Hi-vis&product=...&collection=...
    const about = params.get('product') || params.get('collection');
    const ref = document.referrer && new URL(document.referrer);
    hidden('Product', params.get('product'));
    hidden('Collection', params.get('collection'));
    hidden('Came from', params.get('from') || (ref && ref.host === location.host && ref.pathname !== location.pathname ? ref.pathname : ''));
    if (params.get('need')) tick(params.get('need'));
    else if (about) { const hit = NEED.find(([re]) => re.test(about)); if (hit) tick(hit[1]); }
    if (about) {
      context.textContent = `About: ${about}`;
      const drop = Object.assign(document.createElement('button'), { type: 'button', className: 'ww-link', textContent: 'Not this' });
      drop.addEventListener('click', () => { hidden('Product'); hidden('Collection'); context.hidden = true; });
      context.append(' ', drop);
      context.hidden = false;
    }
    const start = form.querySelector(`[data-intent="${params.get('intent')}"]`);
    if (start) { start.checked = true; choose(start); show(2, false); }
    else show(1, false);
  });
  document.querySelectorAll('[data-ww-product]').forEach(root => {
    const form = root.querySelector('[data-ww-product-form]');
    // A <select> for multi-variant products, a hidden <input> when the product has only the default variant.
    const select = root.querySelector('[data-ww-variant]');
    const fallback = select.closest('.ww-variant-fallback');
    const variants = JSON.parse(root.querySelector('[data-ww-variants]').textContent);
    const radios = [...root.querySelectorAll('[data-option]')];
    const price = root.querySelector('[data-ww-price]');
    const add = root.querySelector('[data-ww-add]');
    const supply = root.querySelector('[data-ww-supply]');
    const message = root.querySelector('[data-ww-product-message]');
    const image = root.querySelector('[data-ww-main-image]');
    const imageLink = root.querySelector('[data-ww-main-link]');
    const thumbs = [...root.querySelectorAll('[data-ww-image]')];
    const canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
    const resetZoom = () => {
      if (!image) return;
      imageLink.classList.remove('is-zooming');
      image.style.removeProperty('transform-origin');
    };
    if (imageLink) {
      const zoomAt = event => {
        if (!canHoverZoom.matches || event.pointerType !== 'mouse') return;
        const rect = imageLink.getBoundingClientRect();
        const x = Math.min(100, Math.max(0, (event.clientX - rect.left) / rect.width * 100));
        const y = Math.min(100, Math.max(0, (event.clientY - rect.top) / rect.height * 100));
        image.style.transformOrigin = `${x}% ${y}%`;
        imageLink.classList.add('is-zooming');
      };
      imageLink.addEventListener('pointerenter', zoomAt);
      imageLink.addEventListener('pointermove', zoomAt);
      imageLink.addEventListener('pointerleave', resetZoom);
      imageLink.addEventListener('blur', resetZoom);
      canHoverZoom.addEventListener?.('change', resetZoom);
    }
    const showImage = url => {
      if (!image) return; // product with no media
      resetZoom();
      image.src = url; imageLink.href = url;
      thumbs.forEach(t => t.setAttribute('aria-pressed', String(t.dataset.wwImage === url)));
    };
    thumbs.forEach(t => t.addEventListener('click', () => showImage(t.dataset.wwImage)));
    const update = (initial = false) => {
      const options = [];
      radios.filter(r => r.checked).forEach(r => { options[Number(r.dataset.option)] = r.value; });
      const v = radios.length ? variants.find(v => v.options.every((value, i) => value === options[i])) : variants.find(v => String(v.id) === select.value);
      const available = Boolean(v?.available);
      select.value = v ? String(v.id) : '';
      select.disabled = !available;
      add.disabled = !available;
      add.textContent = available ? 'Add to cart' : 'Unavailable';
      supply.hidden = !v?.untracked;
      price.textContent = v ? (v.priceText || money(v.price)) : 'Choose another combination';
      message.hidden = true;
      if (v?.image) showImage(v.image);
      syncBar();
      // Only a shopper's choice writes ?variant= into the URL, never the first render.
      if (!initial && v && !root.hasAttribute('data-preview')) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
    };
    // Phones: price, chosen options and Add to cart stay in reach while the real button is off screen.
    // The bar's button presses the real one, so availability, submit and preview rules stay in one place.
    const bar = document.createElement('div');
    bar.className = 'ww ww-stickybuy';
    bar.hidden = true;
    bar.innerHTML = '<p class="ww-stickybuy__info"><span class="ww-num" data-price></span><span data-choice></span></p><button type="button" class="ww-btn ww-btn--primary"></button>';
    document.body.append(bar);
    const barButton = bar.querySelector('button');
    const syncBar = () => {
      bar.querySelector('[data-price]').textContent = price.textContent;
      bar.querySelector('[data-choice]').textContent = radios
        .filter(r => r.checked && root.querySelectorAll(`[data-option="${r.dataset.option}"]`).length > 1).map(r => r.value).join(', ');
      barButton.textContent = picked ? add.textContent : `Choose ${choiceName}`;
      barButton.disabled = picked && add.disabled;
    };
    // The first value is pre-selected, so until the shopper picks (or arrives with ?variant=) the bar asks
    // them to choose rather than adding a size they never looked at.
    const multi = [...new Set(radios.map(r => r.dataset.option))].filter(o => root.querySelectorAll(`[data-option="${o}"]`).length > 1);
    const choiceName = multi.length === 1 ? (radios.find(r => r.dataset.option === multi[0]).closest('fieldset')?.querySelector('legend')?.textContent.trim().toLowerCase() || 'options') : 'options';
    let picked = !multi.length || new URLSearchParams(location.search).has('variant');
    radios.forEach(r => r.addEventListener('change', () => { picked = true; syncBar(); }));
    barButton.addEventListener('click', () => {
      if (picked) { add.click(); return; }
      const first = radios.find(r => r.dataset.option === multi[0]);
      first.closest('fieldset').scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      first.focus({ preventScroll: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting;
        document.body.classList.toggle('ww-has-stickybuy', !entry.isIntersecting);
      }).observe(add);
    }
    // Initialise the separate choices from the native selected variant, including ?variant=.
    const selected = variants.find(v => String(v.id) === select.value);
    if (selected) radios.forEach(r => { r.checked = selected.options[Number(r.dataset.option)] === r.value; });
    if (radios.length) {
      root.querySelector('[data-ww-options]').hidden = false;
      if (fallback) fallback.hidden = true;
      radios.forEach(r => r.addEventListener('change', () => update()));
    } else if (select.tagName === 'SELECT') select.addEventListener('change', () => update());
    update(true);
    form.addEventListener('submit', event => {
      if (add.disabled || !select.value) event.preventDefault();
      // The local preview must never claim to have changed a shopper's cart.
      if (root.hasAttribute('data-preview')) {
        event.preventDefault(); message.textContent = 'This is a preview. Cart checkout is available on the live shop.'; message.hidden = false;
      }
    });
  });

  // Search scope: when landing on bare /search?q=... in the workwear stream without filter.p.tag=stream:workwear,
  // upgrade the URL in-place so pagination and all 24 slots per page are scoped to stream:workwear.
  document.querySelectorAll('.ww-search-page form.ww-search').forEach(form => {
    const q = new URLSearchParams(location.search);
    if (q.has('q') && (q.get('filter.p.tag') !== 'stream:workwear' || q.get('type') !== 'product')) {
      q.set('type', 'product');
      q.set('filter.p.tag', 'stream:workwear');
      location.replace(`${form.action}?${q.toString()}`);
    }
  });

  // Collection sort and filters: one native GET form, store and preview alike. With JS, a change submits it
  // straight away; without JS the Apply button does. Price fields submit on Enter, or when their panel closes.
  document.querySelectorAll('[data-ww-filters]').forEach(form => {
    form.classList.add('ww-filters--js');
    const sortSelect = form.querySelector('[name="sort_by"]');
    if (sortSelect) {
      const urlSort = new URLSearchParams(location.search).get('sort_by');
      const defaultSort = sortSelect.dataset.defaultSort || sortSelect.querySelector('[selected]')?.getAttribute('value') || sortSelect.value;
      if (!urlSort && defaultSort) sortSelect.value = defaultSort;
    }
    const submit = () => (form.requestSubmit ? form.requestSubmit() : form.submit());
    form.addEventListener('change', event => {
      if (event.target.matches('select, input[type="checkbox"]')) submit();
    });
    form.querySelectorAll('details').forEach(panel => {
      const fields = [...panel.querySelectorAll('input[type="number"]')];
      if (!fields.length) return;
      let before = '';
      panel.addEventListener('toggle', () => {
        const now = fields.map(f => f.value).join('|');
        if (panel.open) before = now; else if (now !== before) submit();
      });
    });
  });

  // PREVIEW ONLY: a stand-in for Shopify's server render. It reads the same query string the form sends
  // to the store and renders what the collection template would: checked values, results, empty state, Clear.
  document.querySelectorAll('[data-ww-collection][data-preview]').forEach(root => {
    const form = root.querySelector('[data-ww-filters]');
    const grid = root.querySelector('[data-ww-grid]');
    const cards = [...grid.children];
    const products = JSON.parse(root.querySelector('[data-ww-products]').textContent);
    const q = new URLSearchParams(location.search);
    const brands = q.getAll('filter.p.vendor');
    const min = q.get('filter.v.price.gte') || ''; const max = q.get('filter.v.price.lte') || '';
    const sortSelect = form.querySelector('[name="sort_by"]');
    const defaultSort = sortSelect?.dataset.defaultSort || sortSelect?.querySelector('[selected]')?.getAttribute('value') || sortSelect?.value || 'best-selling';
    const sort = q.get('sort_by') || defaultSort;
    form.querySelectorAll('[name="filter.p.vendor"]').forEach(b => { b.checked = brands.includes(b.value); });
    form.querySelector('[name="filter.v.price.gte"]').value = min;
    form.querySelector('[name="filter.v.price.lte"]').value = max;
    if (sortSelect) sortSelect.value = sort;
    const rows = products.map((p, i) => ({ p, card: cards[i] }));
    let visible = 0;
    rows.forEach(({ p, card }) => {
      const match = (!brands.length || brands.includes(p.vendor)) && (min === '' || p.price >= Number(min) * 100) && (max === '' || p.price <= Number(max) * 100);
      card.hidden = !match; if (match) visible++;
    });
    if (sort === 'price-ascending') rows.sort((a, b) => a.p.price - b.p.price);
    if (sort === 'price-descending') rows.sort((a, b) => b.p.price - a.p.price);
    if (sort === 'title-ascending') rows.sort((a, b) => a.p.title.localeCompare(b.p.title));
    rows.forEach(({ card }) => grid.append(card));
    root.querySelector('[data-ww-empty]').hidden = visible !== 0;
    grid.hidden = visible === 0;
    root.querySelector('[data-ww-clear]').hidden = !(brands.length || min || max);
    root.querySelector('[data-ww-results]').textContent = `${visible} products shown`;
  });
})();
